import {ApiBase} from "./ApiBase";
import {AxiosResponse} from "axios";
import {IInformSummary} from "../model/inform/InformSummary";
import {IInformPerformance} from "../model/inform/InformPerformance";
import {IInformStaff} from "../model/inform/InformStaff";
import {IInformBusiness} from "../model/inform/InformBusiness";
import {IInformRiskManagement} from "../model/inform/InformRiskManagement";
import {IInformProcess} from "../model/inform/InformProcess";
import {IInformTermsAndConditions} from "../model/inform/InformTermsAndConditions";
import {IInformESG} from "../model/inform/InformESG";


export interface IRangeValue {
    value: string,
    date: Date
}

export class InFormReportingApi {
    public static fetchInformSummary(backstopId: number): Promise<IInformSummary | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-summary/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }

    public static fetchInformPerformance(backstopId: number): Promise<IInformPerformance | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-performance/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }

    public static fetchInformStaff(backstopId: number): Promise<IInformStaff | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-staff/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }

    public static fetchInformBusiness(backstopId: number): Promise<IInformBusiness | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-business/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }

    public static fetchInformRiskManagement(backstopId: number): Promise<IInformRiskManagement | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-risk-management/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }

    public static fetchInformProcess(backstopId: number): Promise<IInformProcess | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-process/${backstopId}`, (response: AxiosResponse) => {
            return response.data;
        });
    }

    public static fetchInformTermsAndConditions(backstopId: number): Promise<IInformTermsAndConditions | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-terms-conditions/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }

    public static fetchInformESG(backstopId: number): Promise<IInformESG | undefined> {
        return ApiBase.processGetUnwrapped(`/inform-esg/${backstopId}`,
            (response: AxiosResponse) => {
                return response.data;
            });
    }
}